import type { FaireProductEntity } from "../../entity_types/product";

export const p_bq5cc3tqex: FaireProductEntity = {
  token: "p_bq5cc3tqex",
  type: "product",
  name: "Bergamot + Black Tea Candle",
  brandToken: "b_7ltlwh1w",
  brandName: "True Hue",
  imageUrl:
    "https://cdn.faire.com/fastly/7e2501fc0a856bd545d2bb96bb161639fd757ab44aa121a85401655b11327e06.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/72534f09707c0db82f62140877488e8a9a4996cd61963cce26816d5e4c7db22f.jpeg",
    "https://cdn.faire.com/fastly/53e9fbc779f3312c9d343f8d98ffd1c8f42351bff11059957973fb6a374624f5.png",
    "https://cdn.faire.com/fastly/6fa6dee77e93d5f487adae675e2d97c772c78ddf26eb1c590f7de91718e73ed7.jpeg",
  ],
  priceDollars: 14.5,
  description:
    'Sweet spices pile high in woven baskets, tea leaves steep amongst wildly warm aromas, amber, bergamot, peppercorn.\n\nThis 7.75 oz candle is comprised of a premium soy wax blend and fine fragrance oils (all are Prop 65 and I.F.R.A. approved). Each candle comes complete with a braided cotton wick which burns cleanly for 40-50 hours.\n\nMeasurements:\n\nBox Size: 2.9" L X 2.9" W X 3.3" H\n\nCandle Size: 2.9" D X 3.25" H',
  tags: [],
  msrpDollars: 29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:02.572Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
